var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateFolderInactiveBlueIcon = function SvgCreateFolderInactiveBlueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#245966",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.75 6A2.25 2.25 0 0 1 5 3.75h5.379a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H20A2.25 2.25 0 0 1 22.25 9v9A2.25 2.25 0 0 1 20 20.25H5A2.25 2.25 0 0 1 2.75 18zM15.243 12.871H9.5M12.371 10v5.743"
  })));
};
export { SvgCreateFolderInactiveBlueIcon as ReactComponent };
export default __webpack_public_path__ + "05ce9767bfa18a9081d613da91336dc1.svg";